module.exports = __webpack_public_path__ + "img/查询统计.9f9ea9e0.svg";